/**
 * @generated SignedSource<<3f42ea33d7026df951fed6798d87ae12>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type ProjectV2SingleSelectFieldOptionColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type SingleSelectFieldOptionFragment$data = {
  readonly color: ProjectV2SingleSelectFieldOptionColor;
  readonly id: string;
  readonly name: string;
  readonly nameHTML: string;
  readonly optionId: string;
  readonly " $fragmentType": "SingleSelectFieldOptionFragment";
};
export type SingleSelectFieldOptionFragment$key = {
  readonly " $data"?: SingleSelectFieldOptionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"SingleSelectFieldOptionFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "SingleSelectFieldOptionFragment"
};

(node as any).hash = "8abfa9ab94712bbcb6186d68a86b74ed";

export default node;
